import { Link } from "react-router-dom";
import "./blogcard.css";
export default function BlogCard({ info }) {
  return (
    <article className="blog-card">
      <Link to={info.link} className="blog-card-link">
        <img src={info.image} alt={info.alt} loading="lazy" />
        <div className="blog-card-copy">
          <time>{info.time}</time>
          <h2>{info.title}</h2>
          <p>{info.text}</p>
          <span className="blog-read">Read post →</span>
        </div>
      </Link>
    </article>
  );
}
